// Require

const { id, log, swallow } = require("../std/index")


//
// Shopify Login Controller
//
// Does show/hide of password recovery form
//

module.exports = class LoginController {
  constructor($page, $$) {
    // Dom

    const $mainLoginForm = $$('[data-main-login-form]');
    const $recoveryForm = $$('[data-recovery-form]');
    const $recoveryTrigger = $$('[data-recovery-trigger]');
    const $recoveryCancel = $$('[data-recovery-cancel]');
    const $mainTitle = $$('.page-heading .title');


    // Options

    const recoveryHash = '#recover';
    const speed = 100;
    const originalTitle = $mainTitle.text();
    const altTitle = $page.data('alt-title');


    // Functions

    const setTitle = (text) => {
      $mainTitle.fadeOut(speed, () => {
        $mainTitle.text(text);
        $mainTitle.fadeIn(speed);
      });
    };

    const showForm = () => {
      setTitle(altTitle);
      location.hash = recoveryHash;

      $mainLoginForm.fadeOut(speed, () => {
        $mainLoginForm.hide();
        $recoveryForm.fadeIn(speed);
      });
    };

    const hideForm = () => {
      setTitle(originalTitle);
      location.hash = "";

      $recoveryForm.fadeOut(speed, () => {
        $recoveryForm.hide();
        $mainLoginForm.fadeIn(speed);
      });
    };


    // Listeners

    $recoveryTrigger.on('click', showForm);
    $recoveryCancel.on('click', hideForm);


    // Init - allow deeplinking to recovery form

    if (window.location.hash === recoveryHash) showForm();
    if (typeof LOGIN_CONTROLLER_SHOW_RESET_SUCCESS !== 'undefined' && LOGIN_CONTROLLER_SHOW_RESET_SUCCESS) showForm();
  }
};
